import CartIcon2 from "../Icons/CartIcon2";
import Dropdown from "./Dropdown";
import { useQuery } from "@tanstack/react-query";
import { GetCart } from "../../api/Cart/GetCart";
import { useEffect, useState } from "react";
import { getUserCountry } from "../../utils/utils";
import Button from "./Button";
import { Link } from "react-router-dom";

const CartDropdown = () => {
  const [country, setCountry] = useState<string | null>(null);

  useEffect(() => {
    const userCountry = getUserCountry();
    setCountry(userCountry);
  }, []);

  const { data: CartData } = useQuery({
    queryFn: GetCart,
    queryKey: ["cart"],
    staleTime: 0,
    refetchInterval: 0,
  });

  const cart = CartData?.data;
  const hasCartItems = (cart?.courses && cart.courses.length > 0) || (cart?.packages && cart.packages.length > 0) || (cart?.books && cart.books.length > 0)

  return (
    <Dropdown
      indicator={hasCartItems}
      title="Cart"
      orientation="end"
      toggleImage={<CartIcon2 />}
      toggleClassNames="rounded-full text-slate-400 hover:text-red-500 hover:bg-red-500/10 dark:hover:bg-red-500/20 transition-colors duration-300"
    >
      <div className="px-2 pt-2">
        {hasCartItems ? (
          <>
            <div className="border-b pb-2 mb-2">
              {cart?.courses &&
                cart.courses.map((course) => (
                  <div key={course.id} className="mb-4 flex gap-2">
                    <img
                      src={course.img_url}
                      alt="course"
                      className="w-16 h-16 object-fit rounded"
                    />
                    <div className="w-full flex flex-col justify-between">
                      <h3 className="text-base font-bold">{course.name}</h3>
                      <p className="text-sm">Dr. Mohamed Ismael</p>
                      <h1 className="font-bold">
                        {country === "EG" ? (
                          <>
                            {course.discountPrice_egp
                              ? course.discountPrice_egp
                              : course.actualPrice_egp}{" "}
                            <span className="md:text-sm text-xs uppercase">
                              LE
                            </span>
                          </>
                        ) : (
                          <>
                            <span className="md:text-sm text-xs uppercase">
                              $
                            </span>
                            {course.discountPrice_usd
                              ? course.discountPrice_usd
                              : course.actualPrice_usd}{" "}
                          </>
                        )}
                        &nbsp;&nbsp;
                        <span className="text-gray-400 line-through font-normal">
                          {country === "EG" ? (
                            <>
                              {course.actualPrice_egp}
                              <span className="md:text-sm text-xs uppercase">
                                LE
                              </span>
                            </>
                          ) : (
                            <>
                              <span className="md:text-sm text-xs uppercase">
                                $
                              </span>
                              {course.actualPrice_usd}
                            </>
                          )}
                        </span>
                      </h1>
                    </div>
                  </div>
                ))}
              {cart?.packages &&
                cart.packages.map((pack) => (
                  <div key={pack.id} className="mb-4 flex gap-2">
                    <div className="min-h-16 min-w-16">
                      <svg className="object-fit rounded-lg w-full h-full sm:max-w-24 sm:max-h-24 max-h-16 max-w-16" viewBox="0 0 10 6.7">
                        <defs>
                          <clipPath id="top">
                            <polygon points="0 0, 9.9 0, 0 6.6" />
                          </clipPath>
                          <clipPath id="bottom">
                            <polygon points="10 0.1, 10 6.7, 0.1 6.7" />
                          </clipPath>
                        </defs>
                        {pack.courses.map((course, index) => (
                          <image
                            key={course.id}
                            xlinkHref={course.img_url}
                            x="0"
                            y="0"
                            height="6.7"
                            width="10"
                            clipPath={`url(#${index === 1 ? 'top' : 'bottom'})`}
                          />
                        ))}
                      </svg>
                    </div>
                    <div className="w-full flex flex-col justify-between">
                      <h3 className="md:text-base text-sm font-bold">{pack.name}</h3>
                      <p className="text-sm">Dr. Mohamed Ismael</p>
                      <h1 className="font-bold">
                        {country === "EG" ? (
                          <>
                            {pack.discountPrice_egp
                              ? pack.discountPrice_egp
                              : pack.actualPrice_egp}{" "}
                            <span className="md:text-sm text-xs uppercase">
                              LE
                            </span>
                          </>
                        ) : (
                          <>
                            <span className="md:text-sm text-xs uppercase">
                              $
                            </span>
                            {pack.discountPrice_usd
                              ? pack.discountPrice_usd
                              : pack.actualPrice_usd}{" "}
                          </>
                        )}
                        &nbsp;&nbsp;
                        <span className="text-gray-400 line-through font-normal">
                          {country === "EG" ? (
                            <>
                              {pack.actualPrice_egp}
                              <span className="md:text-sm text-xs uppercase">
                                LE
                              </span>
                            </>
                          ) : (
                            <>
                              <span className="md:text-sm text-xs uppercase">
                                $
                              </span>
                              {pack.actualPrice_usd}
                            </>
                          )}
                        </span>
                      </h1>
                    </div>
                  </div>
                ))}
              {cart?.courses &&
                cart.books.map((book) => (
                  <div key={book.id} className="mb-4 flex gap-2">
                    <img
                      src={book.img_url}
                      alt="course"
                      className="w-16 h-16 object-fit rounded"
                    />
                    <div className="w-full flex flex-col justify-between">
                      <h3 className="text-base font-bold">{book.name}</h3>
                      <p className="text-sm">Dr. Mohamed Ismael</p>
                      <h1 className="font-bold">
                      {country === "EG" ? (
                          <>
                            {book.discountPrice_egp
                              ? book.discountPrice_egp
                              : book.public_EGP_price}{" "}
                            <span className="md:text-sm text-xs uppercase">
                              LE
                            </span>
                          </>
                        ) : (
                          <>
                            <span className="md:text-sm text-xs uppercase">
                              $
                            </span>
                            {book.discountPrice_usd
                              ? book.discountPrice_usd
                              : book.public_USD_price}{" "}
                          </>
                        )}
                        &nbsp;&nbsp;
                        <span className="text-gray-400 line-through font-normal">
                          {country === "EG" ? (
                            <>
                              {book.public_EGP_price}
                              <span className="md:text-sm text-xs uppercase">
                                LE
                              </span>
                            </>
                          ) : (
                            <>
                              <span className="md:text-sm text-xs uppercase">
                                $
                              </span>
                              {book.public_USD_price}
                            </>
                          )}
                        </span>
                      </h1>
                    </div>
                  </div>
                ))}

            </div>
            <div>
              {country === "EG" ? (
                <h1 className="font-bold text-lg">Total: {cart.total_discountPrice_egp}LE <span className="text-gray-400 line-through font-normal">{cart.total_actualPrice_egp}LE</span></h1>
              ) : (
                <h1 className="font-bold text-lg">Total: {cart.total_discountPrice_usd}USD <span className="text-gray-400 line-through font-normal">{cart.total_actualPrice_usd}USD</span></h1>
              )}
              <Link to='/cart-checkout'>
                <Button variant="transparent" className="before:!bg-primary hover:text-white !text-base !font-bold !h-11 mt-2 w-full !border-primary !border-2 text-primary rounded-lg"
                >
                  Checkout
                </Button>
              </Link>
            </div>
          </>
        ) : (
          <h1 className="font-semibold text-lg text-center">
            Your cart is empty, Add something to it
          </h1>
        )}
      </div>
    </Dropdown>
  );
};

export default CartDropdown;
